let zIndex = 1800

export function getZindex() {
  return (zIndex += 2) - 1
}

